import Seo from "../../components/seo";
import Layout from "../../components/layout";
import Header from "../../components/header";
import Footer from "../../components/footer";
import ServiceHero from "../../components/ServiceHero";
import ServiceCTA from "../../components/ServiceCTA";
import { CardColumn } from "../../components/sections";
import { FiCode, FiServer, FiDatabase, FiZap, FiLock, FiSmartphone, FiArrowUp } from "react-icons/fi";
import { usePageMetadata } from "../../hooks/usePageMetadata";

const WebDevelopmentPage = () => {
  usePageMetadata({
    title: 'Web Development - Bercastle',
    description: 'Responsive websites and custom web applications optimized for performance with fast load times and enhanced SEO.',
    pageType: 'service',
    content: {
      service: {
        name: "Web Development",
        tagline: "Modern Web Solutions",
        description: "Responsive websites and custom web applications optimized for performance with fast load times and enhanced SEO.",
        url: "/services/web-development"
      },
      capabilities: [
        {
          name: "Websites",
          description: "Responsive and user-friendly websites that provide seamless navigation across all devices.",
          features: ["Responsive design", "Fast loading times", "SEO optimization", "Mobile-first approach", "Cross-browser compatibility"]
        },
        {
          name: "Web Applications",
          description: "Custom web applications to automate workflows and enhance user interaction.",
          features: ["Custom dashboards", "Business automation", "API integrations", "Real-time features", "User authentication"]
        },
        {
          name: "E-commerce Solutions",
          description: "Full-featured online stores with secure payment processing and inventory management."
        },
        {
          name: "Progressive Web Apps (PWA)",
          description: "App-like experiences that work across all devices with offline capabilities."
        }
      ],
      technologies: ["React, Vue.js, Angular", "Node.js, Python, .NET", "GraphQL, REST APIs", "PostgreSQL, MongoDB", "AWS, Azure, Google Cloud", "Docker, Kubernetes"],
      value_propositions: [
        "Modern tech stack",
        "Performance-first approach",
        "SEO best practices",
        "Scalable architecture",
        "Security-focused",
        "Ongoing support"
      ],
      meta: {
        source_url: "https://bercastle.com/services/web-development",
        service_category: "Web Development"
      }
    }
  });
  const solutionItems = [
    {
      icon: FiCode,
      title: "Websites",
      description: "We design responsive and user-friendly websites that provide seamless navigation across all devices. Our websites are optimized for performance with fast load times and enhanced SEO."
    },
    {
      icon: FiSmartphone,
      title: "Web Applications",
      description: "We build custom web applications to automate workflows, enhance user interaction, and create efficient business operations integrated with your existing systems."
    }
  ];

  const expertiseItems = [
    {
      icon: FiCode,
      title: "Frontend Development",
      description: "We design intuitive and user-friendly interfaces with thoughtful UX. Emphasis on responsiveness, so your site looks great across all devices."
    },
    {
      icon: FiServer,
      title: "Backend Development",
      description: "We power applications with robust server-side business logic, combining powerful features with flawless performance."
    },
    {
      icon: FiDatabase,
      title: "DevOps",
      description: "We combine development and operations to automate app deployment using best practices and modern tools."
    }
  ];

  const benefitItems = [
    {
      icon: FiZap,
      title: "High Performance",
      description: "Fast load times and optimized user experience"
    },
    {
      icon: FiLock,
      title: "Secure by Design",
      description: "Built with security best practices from day one"
    },
    {
      icon: FiSmartphone,
      title: "Responsive",
      description: "Perfect experience across all devices and screens"
    },
    {
      icon: FiArrowUp,
      title: "Scalable",
      description: "Architecture that grows with your business"
    }
  ];
  return (
    <Layout classmain="web-development-page">
      <Seo
        title='Web Development - OnScript AI'
        metaDesciption='Responsive, secure, and high-performance web solutions for companies of all sizes. Custom websites and web applications built to scale.'
      />
      <Header />

      <ServiceHero 
        badge="Web Development"
        title="Build Web Experiences"
        titleHighlight="That Convert"
        description="We deliver responsive, secure, and high-performance web solutions that align with your business goals and exceed user expectations."
        ctaLink="/contact"
      />

      {/* Solutions Section */}
      <div className='py-20'>
        <div className='container-custom'>
          <CardColumn 
            cards={solutionItems}
            cols={2}
            title="Custom Web Solutions"
            description="From concept to deployment, we develop secure digital products that maximize your business potential"
          />
        </div>
      </div>

      {/* Expertise Section */}
      <div className='py-20'>
        <div className='container-custom'>
          <CardColumn 
            cards={expertiseItems}
            cols={3}
            title="Our Web Development Expertise"
            description="Full-stack capabilities from frontend magic to DevOps mastery"
          />
        </div>
      </div>

      {/* Benefits Section */}
      <div className='py-20'>
        <div className='container-custom'>
          <CardColumn 
            cards={benefitItems}
            cols={4}
            title="Why Choose Us?"
            description="Quality, performance, and results-driven development"
          />
        </div>
      </div>

      <ServiceCTA 
        title="Ready to Build Your Web Solution?"
        description="Let's collaborate to create user experiences that align with your long-term business goals and meet customer expectations."
        buttonText="Start Your Web Project"
      />

      <Footer />
    </Layout>
  )
}

export default WebDevelopmentPage
